import { VStack } from "@/components/ui/vstack";
import { View } from "@/components/ui/view";
import { Text } from "@/components/ui/text";
import { ScrollView } from "react-native-gesture-handler";
import i18n from "i18n-js";
import React, { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import Footer from "@/components/basic/Footer";
import ContactElement from "@/components/basic/ContactElement";
import useIsMounted from '@/hooks/mounted';
import ModalConfirm from "@/components/basic/ModalConfirm";
import {useSafeAreaInsets} from "react-native-safe-area-context";

export default function ContactsSelect({ navigation, route, updateChilds }) {

    const { channel, title, isEdit } = route.params
    const contacts = useSelector((state) => state.contacts)
    const mounted = useIsMounted()
    const insets = useSafeAreaInsets()

    const [actContacts, setActContacts] = useState(channel.contacts)
    const [showModal, setShowModal] = useState(false)
    const [action, setAction] = useState()

    const actions = [
        { icon: '' },
        { icon: 'home', text: 'footer.home', component: 'Home' },
        { icon: 'check', text: 'footer.finish', component: 'BACK' }
    ]

    const setContacts = (contactId, isSelected) => {
        if (isSelected) {
            setActContacts(prev => {
                const next = [...prev]
                next.push(contactId)
                return next
            })
        } else {
            setActContacts(prev => {
                const next = prev.filter(id => id != contactId)
                return next
            })
        }
    }

    useEffect(
        () => {
            return navigation.addListener('beforeRemove', (e) => {
                const noneRemoved = channel.contacts.filter(workflow => !actContacts.includes(workflow)).length == 0
                // if there are no deletions
                if (!isEdit || noneRemoved) {
                    return;
                }
                // Prevent default behavior of leaving the screen
                e.preventDefault()
                // Prompt the user before leaving the screen
                setAction(e.data.action)
                setShowModal(true)
            })
        },
        [navigation, actContacts]
    )

    const closeModal = (confirmed) => {
        setShowModal(false)
        if (confirmed) {
            navigation.dispatch(action)
        } else {
            // reset selections
            setActContacts(channel.contacts)
        }
    }

    useEffect(() => {
        navigation.setOptions({ title: title, info: i18n.t('channel.info') })
    }, [])

    useEffect(() => {
        return () => {
            if (!mounted()) {
                if (updateChilds) {
                    updateChilds(actContacts, null)
                }
            }
        };
    }, [mounted])

    return (
        <View className="flex-1 bg-secondary-50">
            <ScrollView scrollIndicatorInsets={{ right: 1 }} contentContainerStyle={{ paddingBottom: 70 + insets.bottom }} className="flex-1 bg-secondary-50">
                <VStack>
                    <Text className="px-3 py-3 text-2xl text-secondary-900">{i18n.t('channel.contacts', { num: contacts.active.length })}</Text>
                    {contacts.active.map((contact, index) => <ContactElement
                        key={'A' + index}
                        uri={contact?.contactImage?.id || contact.toUser.id}
                        title={contact.contactAlias || contact.toUser.mail} text={contact.toUser.preferredName}
                        onPress={setContacts}
                        id={contact.id}
                        selected={actContacts.includes(contact.id)} />)}
                </VStack>
            </ScrollView>
            <ModalConfirm showModal={showModal} closeModal={closeModal} title='shareWorkflow.title' text='shareWorkflow.textChannelExclude' buttonOk='shareWorkflow.ok' />
            <Footer navigation={navigation} actions={actions} />
        </View>
    );
}